import { ApiError } from '@/api/client';

// The server's error code translated (err.<code>), or a general message.
export function errText(t: (k: string) => string, err: unknown) {
  const code = err instanceof ApiError ? err.code : (err as { code?: string })?.code ?? 'server_error';
  const key = `err.${code}`;
  const msg = t(key);
  return msg === key ? t('err.server_error') : msg;
}
